import { Component, OnInit, Input, OnDestroy } from '@angular/core';
// ngrx store
import { Subscription } from 'rxjs';
// services
import { AddQuestionAnswerService } from '../../services/add-question-answer.service';
// models
import { AddQuestionAnswerRequest } from '../../models/question-answer.interface';

@Component({
  selector: 'app-booking-details-tricky',
  templateUrl: './booking-details-tricky.component.html',
  styleUrls: ['./booking-details-tricky.component.scss']
})
export class BookingDetailsTrickyComponent implements OnInit, OnDestroy {

  @Input()
  appCopy;

  @Input()
  selectedLanguage;
  
  @Input()
  bookingRef;

  @Input()
  journeyRef;

  @Input()
  user;

  private _addQuestionAnswerSubscription: Subscription;
  private _getQuestionAnswerSubscription: Subscription;

  public bookingIssues: Array<string> = [
    'Driver was late',
    'Driver was early',
    'Driver slot moved at customer\'s request',
    'Driver - other issue',
    'Issue with airport repatriation',
    'Customer unhappy with call centre',
    'Unhappy with refund policy',
    'Customer generally not happy',
    'Customer not happy with reassignment process',
    'Concerns with excess charge'

  ];
  public issueArray: Array<Object> = [];
  public bookingIssueSelected = null;
  public showAddIssue = false;
  public showAddIssueLoader = false;
  public noBookingIssues = false;
  public bookingIssuesLoaded = false;

  constructor(private _addQuestionAnswerService: AddQuestionAnswerService) { }

  ngOnInit() {
    const getQuestionAnswerRequest = {
      bookingReference: this.bookingRef,
      bookingJourneyReference: this.journeyRef,
      category: 2
    };

    this._addQuestionAnswerService.getQuestionAnswer(getQuestionAnswerRequest, this.user.userToken);

    this._getQuestionAnswerSubscription = this._addQuestionAnswerService.questionAnswerItem$
      .subscribe(res => {
        this.issueArray = res.questionAnswers;

        if (this.issueArray.length === 0) {
          this.noBookingIssues = true;
        } else {
          this.noBookingIssues = false;
        }

        this.showAddIssueLoader = false;
        this.bookingIssuesLoaded = true;
      });

    this._addQuestionAnswerSubscription = this._addQuestionAnswerService.addQuestionAnswer$
      .subscribe(res => {
        if (res) {
          this.toggleAddIssueSection();
          this._addQuestionAnswerService.getQuestionAnswer(getQuestionAnswerRequest, this.user.userToken);
        }
      });
  }

  handleIssueSubmit(value, event: Event) {

    event.preventDefault();

    this.showAddIssueLoader = true;
    this.bookingIssuesLoaded = false;

    const questionAnswerRequest: AddQuestionAnswerRequest = {
      bookingReference: this.bookingRef,
      bookingJourneyReference: this.journeyRef,
      questionAnswer: [{
        question: 'What is the issue?',
        answer: ''
      }],
      client: 2,
      category: 2
    };

    questionAnswerRequest.questionAnswer[0].answer = this.bookingIssues[value.bookingIssue];

    this._addQuestionAnswerService.addQuestionAnswer(questionAnswerRequest, this.user.userToken);
  }

  toggleAddIssueSection() {
    this.showAddIssue = !this.showAddIssue;
  }

  ngOnDestroy() {
    this._addQuestionAnswerSubscription.unsubscribe();
    this._getQuestionAnswerSubscription.unsubscribe();
  }

}
